var render, staticRenderFns
import script from "./dialogDrag.vue?vue&type=script&lang=js"
export * from "./dialogDrag.vue?vue&type=script&lang=js"
import style0 from "./dialogDrag.vue?vue&type=style&index=0&id=5b4b75d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports